import { marker as _ } from '@vandres/ngx-translate-extract-marker';

import { LocalPrivilege, PrivilegesApi } from '../schemas/backend-api';

export {
  DEFAULT_ROLE_FORBIDDEN_PRIVILEGES,
  forbiddenDefaultPrivileges,
} from '@andor/contracts/permissions';

export const defaultPrivileges: LocalPrivilege[] = [
  {
    id: 'editAppSettings',
    label: _('Modify App Settings'),
    description: _('Allows users to change app settings, including colors and logos.'),
    show: true,
    active: false,
  },
  {
    id: 'editAppPermissions',
    label: _('Modify App Permissions'),
    description: _('Grants the ability to create and update app permissions for users.'),
    show: true,
    active: false,
  },
  {
    id: 'manageRooms',
    label: _('Manage Rooms'),
    description: _(
      'Allows users to create, access, edit, and delete rooms, and to open new rooms through invite links.'
    ),
    show: true,
    active: false,
  },
  {
    id: 'closeRoom',
    label: _('Close Room'),
    description: _('Allows users to close a room.'),
    show: false,
    active: false,
  },
  {
    id: 'openChildRoom',
    label: _('Open Child Room'),
    description: _('Allows users to open a sub-room within an existing room.'),
    show: false,
    active: false,
  },
  {
    id: 'closeChildRoom',
    label: _('Close Child Room'),
    description: _('Allows users to close a child room. Users will be moved to the main room.'),
    show: false,
    active: false,
  },
  {
    id: 'muteUser',
    label: _('Mute Participants'),
    description: _('Allows users to mute other participants in the room.'),
    show: true,
    active: false,
  },
  {
    id: 'pokeUser',
    label: _('Poke Participants'),
    description: _('Allows users to send a notification or poke to other participants.'),
    show: true,
    active: true,
  },
  {
    id: 'kickUser',
    label: _('Kick Participants'),
    description: _('Allows users to remove other participants from the room.'),
    show: true,
    active: false,
  },
  {
    id: 'grantAccess',
    label: _('Approve Join Requests'),
    description: _(
      'Allows users to accept or decline requests to join the room, and to access any room directly.'
    ),
    show: true,
    active: false,
  },
  {
    id: 'joinAnyRoom',
    label: _('Join Any Room'),
    description: _(
      'Allows users to enter private rooms and scheduled rooms outside their time window without asking for approval.'
    ),
    show: true,
    active: false,
  },
  {
    id: 'makeRoomPrivate',
    label: _('Create Private Room'),
    description: _('Allows users to create a room that is accessible only by invite.'),
    show: false,
    active: false,
  },
  {
    id: 'useMicrophone',
    label: _('Enable Microphone'),
    description: _('Allows users to activate their microphone in the room.'),
    show: true,
    active: true,
  },
  {
    id: 'useCamera',
    label: _('Enable Camera'),
    description: _('Allows users to turn on their camera or share their screen.'),
    show: true,
    active: true,
  },
  {
    id: 'clearDrawings',
    label: _('Clear Drawings'),
    description: _('Allows users to erase all content from the whiteboard.'),
    show: true,
    active: false,
  },
  {
    id: 'clearTextChat',
    label: _('Clear Text Chat'),
    description: _('Allows users to delete all messages in the chat.'),
    show: false,
    active: false,
  },
  {
    id: 'startRecording',
    label: _('Start Recording'),
    description: _('Allows users to start recording the room.'),
    show: true,
    active: false,
  },
  {
    id: 'grantTalkPermission',
    label: _('Grant Talk Permission'),
    description: _('Allows users to grant talk permission to other participants.'),
    show: true,
    active: false,
  },
  {
    id: 'shareFiles',
    label: _('Share Files'),
    description: _(
      'Allows users to upload files to a room and delete shared files. Everyone in the room can download them.'
    ),
    show: true,
    active: false,
  },
];
